/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { HumanityBatchTrxInfo } from './HumanityBatchTrxInfo';
import type { HumanityTrxFeeInfo } from './HumanityTrxFeeInfo';
import type { HumanityTrxGasInfo } from './HumanityTrxGasInfo';
import type { HumanityTrxMoreDetailInfo } from './HumanityTrxMoreDetailInfo';

export type HumanityTrxDetailInfo = {
    TRXA: string;
    TRXTP: HumanityTrxDetailInfo.TRXTP;
    CBB: string;
    STAT: HumanityTrxDetailInfo.STAT;
    BNO: string;
    BTTRXINFO: HumanityBatchTrxInfo;
    AG: string;
    FROMADDRSINFO: EvmAddressSummaryInfo;
    TOADDRSINFO: EvmAddressSummaryInfo;
    VAL: string;
    TF: HumanityTrxFeeInfo;
    GS: HumanityTrxGasInfo;
    UT: number;
    TRXID: string;
    SNO: string;
    MD: HumanityTrxMoreDetailInfo;
};

export namespace HumanityTrxDetailInfo {

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
    }

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

